import React from 'react'
import BaseIcon from 'react-icon-base'
import { EColors } from 'app/constants/colors'

export type Props = {
  pathProps?: Record<string, any>
  svgProps?: Record<string, any>
}

const Edit: React.FC<Props> = ({ svgProps, pathProps }) => (
  <BaseIcon width="10" height="11" viewBox="0 0 10 11" {...svgProps}>
    <path
      fill={EColors.MEDIUM_GREY}
      fillRule="nonzero"
      d="M0 7.478L7.4 0 10 2.575l-7.599 7.457H0z"
      opacity="1"
      {...pathProps}
    />
  </BaseIcon>
)

export default Edit
